import { render, staticRenderFns } from "./sure1.vue?vue&type=template&id=dfbb5084&scoped=true&"
import script from "./sure1.vue?vue&type=script&lang=js&"
export * from "./sure1.vue?vue&type=script&lang=js&"
import style0 from "./sure1.vue?vue&type=style&index=0&id=dfbb5084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb5084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfbb5084')) {
      api.createRecord('dfbb5084', component.options)
    } else {
      api.reload('dfbb5084', component.options)
    }
    module.hot.accept("./sure1.vue?vue&type=template&id=dfbb5084&scoped=true&", function () {
      api.rerender('dfbb5084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/sure1.vue"
export default component.exports